// The Spark & Spiral Supabase project (accounts, cloud saves and the apps'
// daily leaderboards). Its own module so pages can use the public anon key
// without pulling in supabase-js.
export const SPARK_SUPABASE_URL =
  import.meta.env.VITE_SPARK_SUPABASE_URL ||
  'https://sgbjxmdlvipiirmiklai.supabase.co';
export const SPARK_SUPABASE_ANON_KEY =
  import.meta.env.VITE_SPARK_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNnYmp4bWRsdmlwaWlybWlrbGFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcyMzAxOTcsImV4cCI6MjA2MjgwNjE5N30.DqiQF-CzDErIvIJBkHiXNgax4F5AG1YgVrxl_ZVqZ7I';
